import { createStore, compose, applyMiddleware } from 'redux';
import createRootReducer from './redux/modules';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory()

const composeEnhancers =
  // tslint:disable-next-line
  window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;

const store = createStore(
  createRootReducer(history),
  {},
  composeEnhancers(applyMiddleware(
    routerMiddleware(history)
  ))
);

export default store;



// WEBPACK FOOTER //
// ./src/store.ts